export function buildTransitionAborted() {
    let error = new Error('TransitionAborted');
    error.name = 'TransitionAborted';
    error.code = 'TRANSITION_ABORTED';
    return error;
}
export function isTransitionAborted(maybeError) {
    return (typeof maybeError === 'object' &&
        maybeError !== null &&
        maybeError.code === 'TRANSITION_ABORTED');
}
function isAbortable(maybeAbortable) {
    return (typeof maybeAbortable === 'object' &&
        maybeAbortable !== null &&
        typeof maybeAbortable.isAborted === 'boolean');
}
export function throwIfAborted(maybe) {
    if (isAbortable(maybe) && maybe.isAborted) {
        throw buildTransitionAborted();
    }
}
//# sourceMappingURL=transition-aborted-error.js.map